import { Collapse } from 'antd';
import classNames from 'classnames';
import React, { FC, memo, useCallback, useMemo, useState } from 'react';
import { ReactComponent as CollapseArrow } from 'shared/assets/icons/CollapseArrow.svg';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getSelectedFilter } from 'features/BoxSizeFilter';
import { Box } from 'entities/Box';
import { NoResults } from 'shared/ui/NoResults';
import { getSelectedSizeCodeId } from 'pages/BookingPage';
import { SizeCodeForBooking } from 'entities/SizeCode';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { RentOptionDocument } from 'entities/RentOption';
import { OfficesContainer } from './OfficesContainer';
import { ContactUs } from './ContactUs';
import s from './OfficeCollapse.module.scss';
import { getLoggedUserData } from 'entities/User';
import { Pagination } from 'app/types/common';

interface OfficeCollapseProps {
  offices: Pagination<Box> | undefined;
  rentOptions: RentOptionDocument[] | undefined;
  selectedBoxId: string | undefined;
  onSelectBox: (box: Box, sizeCodeId?: string) => void;
  onBookBox: (box: Box, sizeCodeId?: string) => void;
}

export const OfficeCollapse: FC<OfficeCollapseProps> = memo((props) => {
  const { offices, rentOptions = [], selectedBoxId, onSelectBox, onBookBox } = props;

  const { t } = useAppTranslation('booking');

  const loggedUser = useAppSelector(getLoggedUserData);

  return (
    <>
      {offices?.content.length ? (
        <OfficesContainer
          rentOptions={rentOptions}
          selectedBoxId={selectedBoxId}
          onSelectBox={onSelectBox}
          onBookBox={onBookBox}
          accountType={loggedUser?.accountType}
          offices={offices?.content}
        />
      ) : (
        <NoResults
          title={t("Oops, We don't have any units available")} // eslint-disable-line quotes
          description={t('Contact us and we will find the best offer for you')}
          actions={<ContactUs className="desktop:self-start" />}
        />
      )}
    </>
  );
});
